<script setup lang="ts">
import Modal from '@ui/modal/Modal.vue';
import Toastr from '@ui/toastr/Toastr.vue';
const currentYear = new Date().getFullYear()
</script>
<template>
    <Toastr />
    <Modal />
    <main class="text-base/7 text-gray-800 mt-10">
        <RouterView />
    </main>
    <footer class="p-10">
        <div class="text-sm/6 text-white text-center">
            Powered by <a href="https://clinichq.com" target="_blank" class="text-brand-400 hover:text-brand-300">Clinic
                HQ</a> © {{ currentYear }} - All Rights Reserved
        </div>
    </footer>
</template>
